import { api } from "@/Services/api.common.service";

export function notifyRaw(title: string, type: string) {
  //@ts-ignore
  this.$notify({
    group: "all",
    title,
    type,
    duration: 2500,
  });
}

export function notifyOk(title: string) {
  //@ts-ignore
  this.$notify({
    group: "all",
    title,
    type: "success",
    duration: 2500,
  });
}

export function notifyKO(title: string) {
  //@ts-ignore
  this.$notify({
    group: "all",
    title,
    type: "warn",
    duration: 2500,
  });
}

export function notifyErrorFetchRaw() {
  //@ts-ignore
  this.$notify({
    group: "all",
    title: "Il y a eu une erreur, merci d'actualiser la page",
    type: "error",
    duration: 2500,
  });
}

export async function apiCall(routes: any[]) {
  const apiCalls = Object.values(routes).map((route) => api().get(route));

  const promiseResponse = await Promise.all(apiCalls);
  return promiseResponse.map(({ data }) => data);
}

export async function apiCallRebuild(routes: any[]) {
  const routesName = Object.values(routes);
  const routeKey = Object.keys(routes);

  const apiCalls = routesName.map((route) => api().get(route));

  const promiseResponse = await Promise.all(apiCalls);
  const extractData = promiseResponse.map(({ data }) => data);

  const rebuildObject = {} as any;
  routeKey.forEach((key, index) => {
    rebuildObject[key] = extractData[index];
  });

  return rebuildObject;
}

// return level + image
export const getSizeAvatar = async () => {
  try {
    const rewards = await api().get("account/rewards");
    const data = rewards?.data?.rewards?.anniversaries;

    if (data["5years"]) {
      return { img: "lemon-06.svg", level: 6 };
    } else if (data["4years"]) {
      return { img: "lemon-05.svg", level: 5 };
    } else if (data["3years"]) {
      return { img: "lemon-04.svg", level: 4 };
    } else if (data["2years"]) {
      return { img: "lemon-03.svg", level: 3 };
    } else if (data["1year"]) {
      return { img: "lemon-02.svg", level: 2 };
    } else if (data["3months"]) {
      return { img: "lemon-01.svg", level: 1 };
    } else {
      return { img: "lemon-00.svg", level: 0 };
    }
  } catch (e) {
    console.error(e);
  }
};

export const downloadBilan = (url, name) => {
  api(undefined, "blob")
    .get(url)
    .then((response) => {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Bilan " + name + ".pdf");
      document.body.appendChild(fileLink);

      fileLink.click();
    })
    .catch(console.error);
};
